import { endpoints } from 'modules/endpoints'
import { createBasicManagers } from 'modules/utils/helpers/createBasicManagers'
import { octopusApiClient } from 'modules/utils/httpClient'
import {
  TargetListRequestFilter,
  TargetListRequestSorting,
  TargetUpdateDTO,
  TerritoryTarget,
  TerritoryTargetCreateDTO,
} from '../common/types'

export default createBasicManagers<
  TargetListRequestFilter,
  TargetListRequestSorting,
  TerritoryTarget,
  TerritoryTargetCreateDTO,
  TargetUpdateDTO
>(endpoints.territoryTarget, octopusApiClient)
